import { render, staticRenderFns } from "./SanitasTherapistSearch.vue?vue&type=template&id=34015313&scoped=true&"
import script from "./SanitasTherapistSearch.vue?vue&type=script&lang=js&"
export * from "./SanitasTherapistSearch.vue?vue&type=script&lang=js&"
import style0 from "./SanitasTherapistSearch.vue?vue&type=style&index=0&id=34015313&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34015313",
  null
  
)

export default component.exports